import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

import { ACTION_BY_FILTERS_KEY } from "@/Constants/common";
import {
  _checkInvitedBankCandidate,
  _getInvitedCandidates,
  _autoApproveBankCandidate,
  _removeInvitedCandidate,
  _resendInvitedBankCandidate,
  _sendCandidateInvitation,
} from "@/services/clientcandidates";
import {
  handleAPICatch,
  showSuccessToast,
  showErrorToast,
} from "@/utilities/utils";

import { toastMessageText } from "../../utilities/CommonText";
import { formatInvitedCandidates } from "../../utilities/dataFormatter";
import { fetchCandidateTypes } from "../clientdashboard";
const initialState = {
  isLoading: false,
  isPaginationLoading: false,
  invitedCandidates: [],
  selectedCandidate: [], // list of candidate email
  selectedIndex: [], // list of index
  selectedCandidateIds: [],
  showInvitedModal: false,
  showBulkInvitedModal: false,
  checkInvitedCandidateTypeModal: false,
  newInviteCandidateDetail: [],
  filters: {
    search: "",
    candidateType: "",
    candidateReferenceNo: "",
    candidateName: "",
    candidateId: null,
    candidateRole: null,
    sessionType: "",
    complianceStatus: null,
    miles: null,
    candidateLicenseNo: "",
    candidatePostcode: "",
    invitedDateFrom: "",
    invitedDateTo: "",
    ...ACTION_BY_FILTERS_KEY,
  },
  sorting: {
    sortByColumn: "",
    sortByOrder: "",
  },
  totalCount: 0,
  isSelectedAll: false,
  oldFilters: {},
  isFromAction: false,
  toggleSelected: false,
  pagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
  showFilters: false,
};

export const fetchInvitedCandidates = createAsyncThunk(
  "candidatesInvited/fetchInvitedCandidates",
  async (data, { dispatch, getState }) => {
    const {
      clientCandidatesInvited: { filters, pagination, sorting },
    } = getState();

    if (_.isEmpty(data)) {
      data = {
        ...filters,
      };
    }

    if (pagination.isLastPage) {
      return dispatch(setInvitedCandidatesLoading(false));
    }

    dispatch(setPaginationLoading(pagination.currentPage !== 1));
    dispatch(toggleSelectedAll(false));
    const _data = {
      ...data,
      currentPage: pagination.currentPage,
      ...sorting,
    };
    const response = _getInvitedCandidates(_data);
    response
      .then((res) => {
        const {
          data: { candidates, meta },
        } = res;

        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        let data = formatInvitedCandidates(candidates);
        dispatch(
          updatePagination({
            currentPage: currentPage + 1,
            totalPage: lastPage,
            isLastPage: isLastPage,
          }),
        );
        let prevList =
          currentPage === 1
            ? []
            : _.uniq(getState().clientCandidatesInvited.invitedCandidates);
        let firstcandidate_email =
          data.length > 0 ? data[0].candidate_email : null;
        dispatch(updateTotalCount(totalCount));

        if (
          prevList.length > 0 &&
          prevList.find(
            (item) => item.candidate_email === firstcandidate_email,
          ) !== undefined
        ) {
          //
        } else {
          dispatch(updateInvitedCandidatesList([...prevList, ...data]));
        }
      })
      .catch((error) => {
        // console.log("error", error);
        handleAPICatch(error);
        // return rejectWithValue(error);
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(setInvitedCandidatesLoading(false));
          dispatch(setPaginationLoading(false));
          dispatch(toggleIsFromAction(false));
        }, 10);
      });
  },
);

export const checkInvitedBankedCandidatesOrNot = createAsyncThunk(
  "candidatesInvited/checkInvitedBankedCandidatesOrNot",
  async (data, { dispatch }) => {
    const { email, name, phoneNumber, setSubmitting, isPremiumAccount } = data;

    try {
      // Make the API call using async/await
      const res = await _checkInvitedBankCandidate({ candidateEmail: email });
      const {
        data: { is_candidate_already_exist },
      } = res;

      // If the candidate already exists
      if (is_candidate_already_exist) {
        if (isPremiumAccount) {
          // For premium accounts,
          dispatch(toggleInvitedModal(false));
          dispatch(toggleCheckInvitedCandidateTypeModal(true));
          dispatch(
            updateNewInviteCandidateDetail({ email, name, phoneNumber }),
          );
          setSubmitting(false);
        } else {
          // Show error if the account is not premium
          showErrorToast(toastMessageText?.alreadyRegWithAppLocum);
          setSubmitting(false);
        }
      } else {
        // If the candidate doesn't exist, proceed with adding the new invited banked candidate
        dispatch(addNewInvitedBankedCandidates({ ...data, setSubmitting }));
        // setSubmitting(false);
      }
    } catch (error) {
      handleAPICatch(error);
    }
  },
);

export const addNewInvitedBankedCandidates = createAsyncThunk(
  "candidatesInvited/addNewInvitedBankedCandidates",
  async (data, { dispatch, getState }) => {
    const { email, name, phoneNumber, setSubmitting = true, loading } = data;

    // if (loading) return;
    // setSubmitting(true);

    let response = _sendCandidateInvitation({
      candidate_email: email,
      candidate_name: name,
      candidate_phone: phoneNumber,
      type: "new",
    });
    response
      .then((res) => {
        const {
          data: { message },
        } = res;
        dispatch(toggleCheckInvitedCandidateTypeModal(false));
        dispatch(
          updatePagination({
            ...getState().clientCandidatesInvited.pagination,
            currentPage: 1,
            isLastPage: false,
          }),
        );

        if (message.includes("Applocum has previously")) {
          showErrorToast(message);
        } else {
          showSuccessToast(message);
        }

        // dispatch(toggleInvitedModal(false));
        // showSuccessToast(message);
        dispatch(fetchInvitedCandidates());
        dispatch(toggleInvitedModal(false));
        dispatch(
          fetchCandidateTypes(getState().clientCandidatesInvited.filters),
        );
        dispatch(deSelectAllCandidate());
      })
      .catch((error) => {
        handleAPICatch(error);
        // dispatch(toggleInvitedModal(false));
        // dispatch(toggleCheckInvitedCandidateTypeModal(true));
      })
      .finally(() => {
        setSubmitting(false);
      });
  },
);

export const resendInvitedBankedCandidates = createAsyncThunk(
  "candidatesInvited/resendInvitedBankedCandidates",
  async (data, { dispatch }) => {
    const { selectedCandidateIds, loading, setLoading } = data;

    if (loading) return;
    setLoading(true);

    try {
      const res = await _resendInvitedBankCandidate({
        invitationIds: selectedCandidateIds,
      });
      const {
        data: { message },
      } = res;

      showSuccessToast(message);
      dispatch(fetchCandidateTypes());
      dispatch(deSelectAllCandidate());
    } catch (error) {
      handleAPICatch(error);
    } finally {
      setLoading(false);
    }
  },
);

export const autoApproveBankedCandidates = createAsyncThunk(
  "candidatesInvited/autoApproveBankedCandidates",
  async (data, { dispatch }) => {
    const {
      selectedCandidateIds,
      loading,
      setLoading,
      auto_book_status,
      callback,
    } = data;

    if (loading) return;
    setLoading(true);

    try {
      const res = await _autoApproveBankCandidate({
        selectedCandidateIds,
        auto_book_status,
      });
      const {
        data: { message },
      } = res;
      showSuccessToast(message);
      // dispatch(fetchCandidateTypes());
      dispatch(deSelectAllCandidate());
      callback && callback();
    } catch (error) {
      handleAPICatch(error);
    } finally {
      setLoading(false);
    }
  },
);

export const deleteInvitedCandidatedata = createAsyncThunk(
  "candidatesInvited/deleteInvitedCandidatedata",
  async (data, { dispatch }) => {
    const {
      callback,
      loading,
      setLoading,
      invitation_ids,
      isSelectedAll,
      ignoreIds,
    } = data;
    const _data = {
      invitation_ids,
      isSelectedAll,
      ignoreIds,
    };
    if (loading) return;
    setLoading(true);
    const response = _removeInvitedCandidate(_data);
    response
      .then((res) => {
        const {
          data: { message },
        } = res;
        callback && callback();
        showSuccessToast(message);
        dispatch(deSelectAllCandidate());
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        setLoading(false);
      });
  },
);

const candidatesInvitedSlice = createSlice({
  name: "candidatesInvited",
  initialState,
  reducers: {
    /**
     * Updates the invited candidates list in the state.
     *
     * @param {type} state - the state object
     * @param {type} action - the action object containing the payload
     * @return {void}
     */
    updateInvitedCandidatesList: (state, action) => {
      state.invitedCandidates = action.payload;
    },
    /**
     * Set the loading state for invited candidates.
     *
     * @param {type} state - the current state
     * @param {type} action - the action payload
     * @return {type} description of return value
     */
    setInvitedCandidatesLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setPaginationLoading(state, action) {
      state.isPaginationLoading = action.payload; // New reducer for pagination loading
    },
    /**
     * Update the selected candidate in the state.
     *
     * @param {type} state - the current state
     * @param {type} action - the action object
     * @return {type}
     */
    updateSelectedCandidate: (state, action) => {
      state.selectedCandidate = action.payload;
      if (action.payload.length === 0) {
        state.isSelectedAll = false;
      }
    },
    updateSelectedIndex: (state, action) => {
      state.selectedIndex = action.payload;
    },
    updateSelectedCandidateIds: (state, action) => {
      state.selectedCandidateIds = action.payload;
    },
    /**
     * toggleInvitedModal - Toggles the invited modal based on the action payload.
     *
     * @param {Object} state - The current state object
     * @param {Object} action - The action object containing the payload
     */
    toggleInvitedModal: (state, action) => {
      state.showInvitedModal = action.payload;
    },
    /**
     * toggleBulkInvitedModal - Toggles the bulk invited modal state.
     *
     * @param {type} state - The current state
     * @param {type} action - The action payload
     */
    toggleBulkInvitedModal: (state, action) => {
      state.showBulkInvitedModal = action.payload;
    },
    /**
     * Deselects all candidates.
     *
     * @param {type} state - the state object
     * @param {type} action - the action object
     * @return {type} undefined
     */
    deSelectAllCandidate: (state, action) => {
      state.selectedCandidate = [];
      state.selectedIndex = [];
      state.isSelectedAll = false;
      state.selectedCandidateIds = [];
      state.toggleSelected = !state.toggleSelected;
    },
    /**
     * Updates the filters in the state based on the action payload.
     *
     * @param {object} state - the current state
     * @param {object} action - the action object containing the payload
     */
    updateFilters: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.filters = {
          search: state.filters.search,
          ...initialState.filters,
        };
        return;
      } else {
        if (action.payload.reset) {
          state.filters = initialState.filters;
        } else {
          state.filters = { ...state.filters, ...action.payload };
        }
      }
    },
    updateSorting: (state, action) => {
      state.sorting = action.payload;
    },
    /**
     * Updates the state to show or hide the filter modal, and saves the old filters if the action payload is truthy.
     *
     * @param {Object} state - The current state object
     * @param {Object} action - The action object triggering the state update
     */
    showFilterModal: (state, action) => {
      if (action.payload) {
        state.oldFilters = state.filters;
      }
      state.showFilters = action.payload;
    },
    /**
     * A function to update the state filters with the old filters.
     *
     * @param {object} state - The current state object
     * @param {object} action - The action object
     * @return {void}
     */
    reStateFilters: (state, action) => {
      state.filters = state.oldFilters;
    },
    /**
     * Updates the pagination state with the provided payload.
     *
     * @param {Object} state - The current state object
     * @param {Object} action - The action object containing the payload
     * @return {void}
     */
    updatePagination: (state, action) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
    /**
     * Updates the toggleSelected property in the state by toggling its value.
     *
     * @param {object} state - the current state object
     * @param {object} action - the action object
     * @return {void}
     */
    updateToggleSelected: (state, action) => {
      state.toggleSelected = !state.toggleSelected;
    },
    /**
     * Toggles the value of 'isFromAction' in the state based on the payload from the action.
     *
     * @param {Object} state - The current state object
     * @param {Object} action - The action object with payload
     */
    toggleIsFromAction: (state, action) => {
      state.isFromAction = action.payload;
    },
    updateTotalCount: (state, action) => {
      state.totalCount = action.payload;
    },
    toggleSelectedAll: (state, action) => {
      state.isSelectedAll = action.payload;
    },
    updateCandidateStatus: (state, action) => {
      let { unsuitable, sortlisted, isSelectedAll, ignoreIds, ids } =
        action.payload;
      let _ids = ids.map((id) => id.toString());
      let _ignoreIds = ignoreIds.map((id) => id.toString());
      state.invitedCandidates = state.invitedCandidates.map((candidate) => {
        if (_ignoreIds.includes(candidate?.candidate_id?.toString())) {
          return candidate;
        }
        if (
          _ids.includes(candidate?.candidate_id?.toString()) ||
          isSelectedAll
        ) {
          candidate.candidate_unsuitable = unsuitable;
          candidate.candidate_sortlisted = sortlisted;
        }
        return candidate;
      });
    },
    toggleCheckInvitedCandidateTypeModal: (state, action) => {
      state.checkInvitedCandidateTypeModal = action.payload;
    },
    updateNewInviteCandidateDetail: (state, action) => {
      state.newInviteCandidateDetail = action.payload;
    },
  },
});

export const {
  updateInvitedCandidatesList,
  updateSelectedCandidate,
  updateSelectedIndex,
  updateSelectedCandidateIds,
  toggleInvitedModal,
  toggleBulkInvitedModal,
  deSelectAllCandidate,
  setInvitedCandidatesLoading,
  setPaginationLoading,
  updateFilters,
  updateSorting,
  showFilterModal,
  updatePagination,
  updateToggleSelected,
  toggleIsFromAction,
  reStateFilters,
  updateTotalCount,
  toggleSelectedAll,
  updateCandidateStatus,
  toggleCheckInvitedCandidateTypeModal,
  updateNewInviteCandidateDetail,
} = candidatesInvitedSlice.actions;

export default candidatesInvitedSlice.reducer;
